import type { StatusTone } from '../contracts/common';
import type { ApiTokenStatus } from '../contracts/tokens';
import type { ApiTokenAccess, ApiTokenKind } from '../enums';

export const API_TOKEN_KIND_LABELS: Record<ApiTokenKind, string> = {
  pat: 'Token osobisty (MCP)',
  runner: 'Token runnera',
  run: 'Token przebiegu',
  oauth: 'Konektor (OAuth)',
};

export const API_TOKEN_ACCESS_LABELS: Record<ApiTokenAccess, string> = {
  read: 'Tylko odczyt',
  write: 'Odczyt i zapis',
};

export const API_TOKEN_ACCESS_DESCRIPTIONS: Record<ApiTokenAccess, string> = {
  read: 'Agent czyta kontekst, zadania, czas i wiedzę. Niczego nie zapisuje.',
  write:
    'Agent może też tworzyć zadania, zapisywać czas, szkice i przebiegi. Maile, faktury i wdrożenia i tak idą przez Akceptacje.',
};

/** Przełącznik w „Nowy token” (Fala 6, DECISIONS 2026-10-06: zlecanie pracy runnerowi przez MCP osobną flagą). */
export const API_TOKEN_LOCAL_RUNNER_LABEL = 'Może zlecać pracę na moim komputerze';
export const API_TOKEN_LOCAL_RUNNER_RISK =
  'Agent z tym tokenem może przez MCP zlecić pracę lokalnemu runnerowi: Claude Code na Twoim komputerze zmieni kod w repozytorium projektu z zakresu tokenu i uruchomi jego testy. Włącz tylko dla agenta, któremu ufasz. Zlecenia „Zleć Claude” z aplikacji działają bez tej opcji.';
/** Dopisek w liście tokenów. */
export const API_TOKEN_LOCAL_RUNNER_SHORT = 'zleca pracę na komputerze';

export const API_TOKEN_STATUS_LABELS: Record<ApiTokenStatus, string> = {
  active: 'Aktywny',
  expired: 'Wygasł',
  revoked: 'Cofnięty',
};

export const API_TOKEN_STATUS_TONES: Record<ApiTokenStatus, StatusTone> = {
  active: 'success',
  expired: 'neutral',
  revoked: 'neutral',
};

/** „90 dni”, „rok”. */
export function tokenExpiryLabel(days: number): string {
  if (days === 365) return 'rok';
  return `${days} dni`;
}

/** Opis zakresu tokenu w liście: „Wszystko”, „REA, HelpMyCar”, „Projekt: Redesign strony”. */
export function tokenScopeLabel(scope: {
  all: boolean;
  clients: { name: string }[];
  projects: { name: string }[];
}): string {
  if (scope.all) return 'Wszystko, do czego masz dostęp';
  const parts = [...scope.clients.map((c) => c.name), ...scope.projects.map((p) => `projekt ${p.name}`)];
  return parts.length > 0 ? parts.join(', ') : 'Tylko własny przebieg';
}
